import React from "react"
import {
    Typography,
    createStyles,
    makeStyles,
} from "@material-ui/core"


const useStyles = makeStyles((theme) =>
  createStyles({
    key:{
        fontSize:"12px",
        textAlign: "start",
        flex: 3,
    },
    value:{
        fontSize:"14px",
        fontWeight: "bold",
        textAlign: "end",
        flex: 1,
    },
  })
)
const styles = {
    container:{
        backgroundColor:"#ffffff",
        color: "#000000",
        fontWeight: "bold",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: "10px 1px",
        padding: "10px",
        borderRadius: "10px",
        boxShadow: "0 5px 12px 0 rgba(217, 226, 233, 0.5)",
        
    }
}
const BodySection = (props) => {
    const classes = useStyles();
    const {keyTitle, value} =  props
    return(
        <div style={styles.container}>
            <Typography className={classes.key} >{keyTitle}</Typography>
            <Typography className={classes.value} noWrap={true} >{value}</Typography>
        </div>
    )
}

export default BodySection
